import { axiosRef } from '.';

export const fetchPackagesTypesList = (payload?: any) => {
  let url = `/package_types?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_common) {
    url = url + `is_common=${payload.is_common}&`;
  }
  if (payload && payload.is_pharma) {
    url = url + `is_pharma=${payload.is_pharma}&`;
  }
  if (payload && payload.is_dangerous_goods) {
    url = url + `is_dangerous_goods=${payload.is_dangerous_goods}&`;
  }
  if (payload && payload.is_active) {
    url = url + `is_active=${payload.is_active}&`;
  }
  return axiosRef.get(url);
};

export const deletePackageType = (id: any) =>
  axiosRef.delete(`/package_types/${id}`);

export const updatePackageType = (payload: any) => {
  // delete payload.carriers;
  let updatedPayload = payload;
  delete updatedPayload.carriers;
  return axiosRef.put(`/package_types/${updatedPayload.id}`, updatedPayload);
};

export const addPackageType = (payload: any) => {
  let updatedPayload = payload;
  delete updatedPayload.carriers;
  return axiosRef.post(`/package_types`, updatedPayload);
};

export const fetchAPIsList = (payload?: any) => {
  let url = `/api?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.category) {
    url = url + `category=${payload.category}&`;
  }
  if (payload && payload.is_active) {
    url = url + `is_active=${payload.is_active}&`;
  }
  return axiosRef.get(url);
};

export const updateDevApi = (payload: any) =>
  axiosRef.put(`/api/${payload.id}`, payload);

export const addDevApi = (payload: any) => axiosRef.post(`/api`, payload);

export const fetchPermissionsList = (payload?: any) => {
  let url = `/api_permission?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.category) {
    url = url + `category=${payload.category}&`;
  }
  if (payload && payload.is_active) {
    url = url + `is_active=${payload.is_active}&`;
  }
  if (payload && payload.is_admin) {
    url = url + `is_admin=${payload.is_admin}&`;
  }
  return axiosRef.get(url);
};

export const deleteDevPermission = (id: any) =>
  axiosRef.delete(`/api_permission/${id}`);

export const addDevPermission = (payload: any) =>
  axiosRef.post(`/api_permission`, payload);

export const updateDevPermission = (payload: any) =>
  axiosRef.put(`/api_permission/${payload.id}`, payload);

export const fetchTiersList = (payload?: any) => {
  let url = `/tiers?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const addDevTier = (payload: any) => axiosRef.post(`/tiers`, payload);

export const editDevTier = (payload: any) =>
  axiosRef.put(`/tiers/${payload.id}`, payload);

export const deleteDevTier = (id: any) => axiosRef.delete(`/tiers/${id}`);

export const fetchErrorCodesList = (payload?: any) => {
  let url = `/error/codes?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const fetchSearchShipments = (payload: any, isAdmin: boolean) => {
  let url = `${isAdmin ? 'admin' : ''}/search_shipments?is_pagination=False&`;
  if (payload && payload.search) {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.start_date) {
    url = url + `start_date=${payload.start_date}&`;
  }
  if (payload && payload.end_date) {
    url = url + `end_date=${payload.end_date}&`;
  }
  if (isAdmin && payload && payload.account && payload.account !== '') {
    url = url + `account=${payload.account}&`;
  }
  return axiosRef.get(url);
};

export const fetchDgGoods = (payload: any) => {
  let url = `/dangerous_goods/unnumbers?`;
  if (payload && payload.search) {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const fetchUserRolesData = (payload: any) => {
  let url = `/user_roles?`;
  if (payload && payload.search) {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  return axiosRef.get(url);
};

export const deleteTracking = (payload: any) =>
  axiosRef.delete(`/track`, { data: payload });

export const fetchJobsList = (payload: any) => {
  let url = `/jobs?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.startDate && payload.endDate) {
    url = url + `start_date=${payload.startDate}&end_date=${payload.endDate}&`;
  }
  if (payload && payload.username && payload.username !== '') {
    url = url + `username=${payload.username}&`;
  }
  if (payload && payload.account && payload.account !== '') {
    url = url + `account=${payload.account}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.status && payload.status !== '') {
    url = url + `status=${payload.status}&`;
  }
  if (payload && payload.projectCode && payload.projectCode !== '') {
    url = url + `project_code=${payload.projectCode}&`;
  }
  return axiosRef.get(url);
};

export const addJob = (payload: any) => axiosRef.post(`/jobs?`, payload);

export const fetchJobDetails = (gatewayNumber: string) =>
  axiosRef.get(`/jobs/${gatewayNumber}`);

export const fetchProjectList = (payload: any) => {
  let url = `/projects?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.owner && payload.owner !== '') {
    url = url + `owner=${payload.owner}&`;
  }
  if (payload && payload.start_date && payload.end_date) {
    url =
      url + `start_date=${payload.start_date}&end_date=${payload.end_date}&`;
  }
  return axiosRef.get(url);
};

export const addProject = (payload: any) => axiosRef.post(`/projects`, payload);

export const fetchProjectDetails = (id: string) =>
  axiosRef.get(`/projects/${id}`);

export const fetchJobSummary = (payload: any) => {
  let url = `/job_summary?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.ProjectCode && payload.ProjectCode !== '') {
    url = url + `project_code=${payload.ProjectCode}`;
  }
  return axiosRef.get(url);
};

export const editJobSummary = (payload: any) =>
  axiosRef.put(`/job_summary/${payload.id}`, payload);

export const fetchSetLanesList = (payload: any) => {
  let url = `/air-to-air-lane?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.origin_airport && payload.origin_airport !== '') {
    url = url + `origin_airport=${payload.origin_airport}&`;
  }
  if (
    payload &&
    payload.destination_airport &&
    payload.destination_airport !== ''
  ) {
    url = url + `destination_airport=${payload.destination_airport}&`;
  }
  if (payload && payload.middle_location && payload.middle_location !== '') {
    url = url + `middle_location=${payload.middle_location}&`;
  }
  if (payload && payload.airline_one && payload.airline_one !== '') {
    url = url + `airline_one=${payload.airline_one}&`;
  }
  if (payload && payload.airline_two && payload.airline_two !== '') {
    url = url + `airline_two=${payload.airline_two}&`;
  }
  return axiosRef.get(url);
};

export const addSetLane = (payload: any) =>
  axiosRef.post(`/air-to-air-lane`, payload);

export const editSetLane = (payload: any) =>
  axiosRef.put(`/air-to-air-lane/${payload.id}`, payload);

export const deleteSetLane = (id: any) =>
  axiosRef.delete(`/air-to-air-lane/${id}`);

export const fetchAirBases = () => axiosRef.get(`/airbase_codes`);

export const fetchAirports = (payload: any) => {
  let url = `/airports?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const fetchAnnoucementList = (payload: any) => {
  let url = `/admin/announcements?`;
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.page !== undefined) {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.publish_date && payload.publish_date !== '') {
    url = url + `publish_date=${payload.publish_date}&`;
  }
  if (payload && payload.type && payload.type !== '') {
    url = url + `type=${payload.type}&`;
  }
  return axiosRef.get(url);
};

export const addAnnouncement = (payload: any) =>
  axiosRef.post(`/admin/announcements`, payload);

export const editAnnouncement = (payload: any) =>
  axiosRef.put(`/admin/announcements/${payload.id}`, payload);

export const deleteAnnouncement = (id: any) =>
  axiosRef.delete(`/admin/announcements/${id}`);
